export interface IRemoveLiftReportInput {
  goalId: string;
}

class RemoveLiftReportInput {
  public readonly goalId: string;

  constructor({ goalId }: { goalId: string }) {
    this.goalId = goalId;
  }

  public toJSON = () => ({
    goalId: this.goalId,
  });

  public static fromJSON = (json: IRemoveLiftReportInput): RemoveLiftReportInput => {
    const { goalId } = Object.assign({}, json);

    if (typeof goalId !== 'string') throw new Error('.goalId must be a string');

    return new RemoveLiftReportInput({
      goalId,
    });
  };
}

export default RemoveLiftReportInput;
